/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import ShoppingCart from '../../../../components/organisms/Panel/ShoppingCart'; // Actions

import * as shoppingCartActions from '../../../../store/reducers/payment/shoppingCart/actions';
var actions = [shoppingCartActions];

function mapStateToProps(state) {
  return {
    shoppingCartState: state.shoppingCart
  };
}

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
ShoppingCart.propTypes = {
  data: PropTypes.array.isRequired
};